import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr";

import {
    Col,
    Row,
    Card,
    CardBody,
    Container,
    Label,
    Input,
    InputGroup,
    Form,
    FormFeedback,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Button,
    Spinner,
    CardFooter,
    CardTitle,
    FormGroup
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik";

//import components
import Breadcrumbs from "../../components/Common/Breadcrumb2.js"
import { withTranslation } from "react-i18next"
import "../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../contexts/ModalContext.js";
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang";
import moment from "moment";
import MyEditor from "components/MyEditor";
import UploadFileS3 from "components/UploadFileS3";
import InputAttachment from "components/Input/attachment/InputAttachment";
import PopupAttachment from "components/Input/attachment/PopupAttachment";
import UploadDesc from "components/UploadDesc";
import { ReactSortable } from 'react-sortablejs';
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner";
import { slugify } from "helpers/fn_helper";

// Services
import {
    SearchWorldclassContent,
    GetWorldclassContentById,
    CreateWorldclassContent,
    UpdateWorldclassContent,
    PatchWorldclassContent,
    DeleteWorldclassContent,
} from "./_services/Services.js";

import configWebRoute from "services/api/configWebRoute"
import CardPieceWorldclass from "./_components/CardPieceWorldclass.js";
import Error401 from "components/Error401.jsx";

const wr = configWebRoute

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const DEF_SORT = [1,2,3,4,5]

const BusinessPurposeWorldclassTemplate = ({
    mainId = 1,
    pageView = "create",
    componentKey = "",
}) => {
    const _pageName = `Business Purpose World Class`
    const _routeLink = `business-purpose/worldclass`
    const _parentComponent = wr.BUSINESS_PURPOSE
    const _routePermission = `business-purpose:section-5`

    // POPUP
    const { mAlert } = useContext(ModalContext);

    // OTHER STATE
    const qParams = useParams()
    const qLang = _.upperCase(qParams?.lang) ?? 'TH'
    // const qMainId = 1
    // const componentKey = qParams?.componentKey
    const navigate = useNavigate();

    const [waitSendData, setWaitSendData] = useState(false)
    const [contentLoading, setContentLoading] = useState(false)

    const [contentCard1Show, setcontentCard1Show] = useState(false)
    const [contentCard2Show, setcontentCard2Show] = useState(false)
    const [contentCard3Show, setcontentCard3Show] = useState(false)
    const [contentCard4Show, setcontentCard4Show] = useState(false)
    const [contentCard5Show, setcontentCard5Show] = useState(false)

    const [cardSeq, setCardSeq] = useState(DEF_SORT)

    const mainIdDb = mainId;
    // ========== Form Validation ========== //
    const validationSchema = Yup.object({
        contentDetail: Yup.string().required("Please Enter Section Detail"),

        contentCard1Show: Yup.boolean(),
        // contentCard1Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 1 Image"),
        contentCard1Title: Yup.string().max(100),
        contentCard1Detail: Yup.string(),

        contentCard2Show: Yup.boolean(),
        // contentCard2Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 2 Image"),
        contentCard2Title: Yup.string().max(100),
        contentCard2Detail: Yup.string(),

        contentCard3Show: Yup.boolean(),
        // contentCard3Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 3 Image"),
        contentCard3Title: Yup.string().max(100),
        contentCard3Detail: Yup.string(),

        contentCard4Show: Yup.boolean(),
        // contentCard4Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 4 Image"),
        contentCard4Title: Yup.string().max(100),
        contentCard4Detail: Yup.string(),

        contentCard5Show: Yup.boolean(),
        // contentCard5Image: Yup.object().test(
        //     "is-not-empty-object",
        //     "Please Upload Image Box",
        //     (value) => value && Object.keys(value).length > 0
        // ).required("Please Upload Card 5 Image"),
        contentCard5Title: Yup.string().max(100),
        contentCard5Detail: Yup.string(),

        contentUpdateDate: Yup.string().max(100),
        contentStatus: Yup.string().max(100),
    })


    // LOCAL STATE FORM
    const [updatedValidationSchema, setUpdatedValidationSchema] = useState(validationSchema)

    const initialValues = {
        contentId: "",

        // Content
        contentDetail: "",

        contentCard1Show: "",
        contentCard1Detail: "",
        contentCard1Title: "",

        contentCard2Show: "",
        contentCard2Detail: "",
        contentCard2Title: "",

        contentCard3Show: "",
        contentCard3Detail: "",
        contentCard3Title: "",

        contentCard4Show: "",
        contentCard4Detail: "",
        contentCard4Title: "",

        contentCard5Show: "",
        contentCard5Detail: "",
        contentCard5Title: "",

        worldclassBg: {},
        card1Image: {},
        card2Image: {},
        card3Image: {},
        card4Image: {},
        card5Image: {},

        contentUpdateDate: moment().format('YYYY-MM-DD'),
        contentStatus: "active",
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: initialValues,
        validationSchema: updatedValidationSchema,
        onSubmit: values => {
            console.log("🚀 ~ ExecutivesPageCreate ~ values:", values)
            
            const valueSort = fnSortCardSeq(cardSeq,
                [
                    {
                        contentCardShow: values.contentCard1Show,
                        contentCardDetail: values.contentCard1Detail,
                        contentCardTitle: values.contentCard1Title,
                        cardImage: values.card1Image,
                    },
                    {
                        contentCardShow: values.contentCard2Show,
                        contentCardDetail: values.contentCard2Detail,
                        contentCardTitle: values.contentCard2Title,
                        cardImage: values.card2Image,
                    },
                    {
                        contentCardShow: values.contentCard3Show,
                        contentCardDetail: values.contentCard3Detail,
                        contentCardTitle: values.contentCard3Title,
                        cardImage: values.card3Image,
                    },
                    {
                        contentCardShow: values.contentCard4Show,
                        contentCardDetail: values.contentCard4Detail,
                        contentCardTitle: values.contentCard4Title,
                        cardImage: values.card4Image,
                    },
                    {
                        contentCardShow: values.contentCard5Show,
                        contentCardDetail: values.contentCard5Detail,
                        contentCardTitle: values.contentCard5Title,
                        cardImage: values.card5Image,
                    }
                ]
            )

            const payload = {
                componentKey: componentKey,

                contentDetail: values.contentDetail,

                contentCard1Show: valueSort[0].contentCardShow,
                contentCard1Detail: valueSort[0].contentCardDetail,
                contentCard1Title: valueSort[0].contentCardTitle,

                contentCard2Show:valueSort[1].contentCardShow,
                contentCard2Detail:valueSort[1].contentCardDetail,
                contentCard2Title:valueSort[1].contentCardTitle,

                contentCard3Show:valueSort[2].contentCardShow,
                contentCard3Detail:valueSort[2].contentCardDetail,
                contentCard3Title:valueSort[2].contentCardTitle,

                contentCard4Show:valueSort[3].contentCardShow,
                contentCard4Detail:valueSort[3].contentCardDetail,
                contentCard4Title:valueSort[3].contentCardTitle,

                contentCard5Show:valueSort[4].contentCardShow,
                contentCard5Detail:valueSort[4].contentCardDetail,
                contentCard5Title:valueSort[4].contentCardTitle,

                attachmentData: {
                    
                },

                contentAttachmentData: {
                    worldclassBg: values.worldclassBg,
                    card1Image: valueSort[0]?.cardImage ? valueSort[0].cardImage : undefined,
                    card2Image: valueSort[1]?.cardImage ? valueSort[1].cardImage : undefined,
                    card3Image: valueSort[2]?.cardImage ? valueSort[2].cardImage : undefined,
                    card4Image: valueSort[3]?.cardImage ? valueSort[3].cardImage : undefined,
                    card5Image: valueSort[4]?.cardImage ? valueSort[4].cardImage : undefined,
                },

                contentUpdateDate: values.contentUpdateDate,
                contentStatus: values.contentStatus,
            };

            console.log("🚀 ~ onSave ~ payload:", payload);

            setWaitSendData(true)
            if (pageView === "update") {
                API.fetchUpdateContent(payload)
            } else {
                API.fetchCreateContent(payload)
            }
        },
    })

    const fnSortCardSeq = (seqNoSort = [], valueList = []) => {
        let newValueList = []
        for (let no of seqNoSort) {
            console.log('no', no)
            const valueWithNo = valueList.find((item,i) => (i + 1)  == no)
            newValueList.push(valueWithNo)
        }

        return newValueList
    }

    // Handle the end of sorting to update the card sequence
    const handleSortEnd = (newSeq) => {
        setCardSeq(newSeq);  // Update the cardSeq state
        validation.setFieldValue("cardSeq", newSeq);  // Synchronize with Formik
    };

    const preFilInput = (resData = {}) => {
        console.log("🚀 ~ preFilInputPage ~ resData:", resData)
        // resetForm(validation.values, initialValues)
        validation.setFieldValue("contentId", resData?.contentId ?? "")

        validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")

        setcontentCard1Show(resData?.contentCard1Show ?? false)
        validation.setFieldValue("contentCard1Show", resData?.contentCard1Show ?? "")
        validation.setFieldValue("contentCard1Detail", resData?.contentCard1Detail ?? "")
        validation.setFieldValue("contentCard1Title", resData?.contentCard1Title ?? "")

        setcontentCard2Show(resData?.contentCard2Show ?? false)
        validation.setFieldValue("contentCard2Show", resData?.contentCard2Show ?? "")
        validation.setFieldValue("contentCard2Detail", resData?.contentCard2Detail ?? "")
        validation.setFieldValue("contentCard2Title", resData?.contentCard2Title ?? "")

        setcontentCard3Show(resData?.contentCard3Show ?? false)
        validation.setFieldValue("contentCard3Show", resData?.contentCard3Show ?? "")
        validation.setFieldValue("contentCard3Detail", resData?.contentCard3Detail ?? "")
        validation.setFieldValue("contentCard3Title", resData?.contentCard3Title ?? "")

        setcontentCard4Show(resData?.contentCard4Show ?? false)
        validation.setFieldValue("contentCard4Show", resData?.contentCard4Show ?? "")
        validation.setFieldValue("contentCard4Detail", resData?.contentCard4Detail ?? "")
        validation.setFieldValue("contentCard4Title", resData?.contentCard4Title ?? "")

        setcontentCard5Show(resData?.contentCard5Show ?? false)
        validation.setFieldValue("contentCard5Show", resData?.contentCard5Show ?? "")
        validation.setFieldValue("contentCard5Detail", resData?.contentCard5Detail ?? "")
        validation.setFieldValue("contentCard5Title", resData?.contentCard5Title ?? "")

        validation.setFieldValue("worldclassBg", resData?.contentWorldclassBg ?? "")
        validation.setFieldValue("card1Image", resData?.contentCard1Image ?? "")
        validation.setFieldValue("card2Image", resData?.contentCard2Image ?? "")
        validation.setFieldValue("card3Image", resData?.contentCard3Image ?? "")
        validation.setFieldValue("card4Image", resData?.contentCard4Image ?? "")
        validation.setFieldValue("card5Image", resData?.contentCard5Image ?? "")

        validation.setFieldValue("contentUpdateDate", resData?.contentUpdateDate ?? moment().format('YYYY-MM-DD'))
        validation.setFieldValue("contentStatus", resData?.contentStatus ?? "active")
    }

    const API = {
        fetchGetContentById: async (mainId) => {
            try {
                const response = await GetWorldclassContentById(mainId, {
                    lang: qLang,
                })
                const resData = response?.data
                if (resData.status == 200) {
                    preFilInput(resData.data)
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong 001",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setContentLoading(false)
            }
        },
        fetchCreateContent: async (payload) => {
            try {
                const response = await CreateWorldclassContent({ data: payload, lang: qLang })
                const resData = response.data
                if (resData.status == 201) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Created Data Success",
                        content: "",
                        onClose: () => {
                            navigate(`/${_routeLink}/worldclass/${qLang}`)
                            window.location.reload()
                        },
                    })
                }
            } catch (e) {
                console.log(e)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
        fetchUpdateContent: async (payload) => {
            try {
                const response = await UpdateWorldclassContent(mainIdDb, {
                    data: payload,
                    lang: qLang,
                })
                const resData = response.data
                if (resData.status == 202) {
                    mAlert.info({
                        title: "Alert",
                        subTitle: "Update Data Success",
                        content: "",
                        onClose: () => {
                            navigate(
                                window.location.reload()
                            )
                        },
                    })
                }
            } catch (err) {
                console.log("err ", err)
                mAlert.info({
                    title: "Alert",
                    subTitle: "Something went wrong",
                    content: "",
                    onClose: () => {
                        //  alert("onClose")
                    },
                })
            } finally {
                setWaitSendData(false)
            }
        },
    }

    // กรณี Edit
    useEffect(() => {
        if (["update", "view"].includes(pageView)) {
            setContentLoading(true)
            API.fetchGetContentById(mainIdDb)
        }
    }, [qLang])

    useEffect(() => {
        console.log('validation.values', validation.values)
    }, [])

    useEffect(() => {
        document.getElementById(`contentCard1Show`).checked = contentCard1Show
        document.getElementById(`contentCard2Show`).checked = contentCard2Show
        document.getElementById(`contentCard3Show`).checked = contentCard3Show
        document.getElementById(`contentCard4Show`).checked = contentCard4Show
        document.getElementById(`contentCard5Show`).checked = contentCard5Show
    }, [contentCard1Show, contentCard2Show, contentCard3Show, contentCard4Show, contentCard5Show])

    // useEffect(() => {
    //     const elements = document.querySelectorAll("#sort-worldclass");
    //     console.log("🚀 ~ useEffect ~ elements:", elements);

    //     if (elements.length > 0) {
    //         const sortableInstance = Sortable.create(elements[0], {
    //             animation: 150,
    //             onEnd: (evt) => {
    //                 console.log('evt.oldIndex:', evt.oldIndex);
    //                 console.log('evt.newIndex:', evt.newIndex);

    //                 // อัปเดตลำดับข้อมูลใน cardSeq เมื่อมีการลากแล้วเปลี่ยนตำแหน่ง
    //                 const updatedCardSeq = [...cardSeq];
    //                 const [movedItem] = updatedCardSeq.splice(evt.oldIndex, 1);
    //                 updatedCardSeq.splice(evt.newIndex, 0, movedItem);
    //                 setCardSeq(updatedCardSeq);

    //                 console.log("Updated cardSeq:", updatedCardSeq);
    //             },
    //         });

    //         return () => {
    //             sortableInstance.destroy();
    //         };
    //     }

    // }, [contentLoading, cardSeq])

    const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
    document.title = `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

    const itemStyle = {
        padding: '10px',
        border: '1px solid black',
        margin: '5px',
        borderRadius: '8px',
        background: '#f9f9f9',
        transition: 'transform 0.2s ease, background-color 0.3s ease',
    };

    const mapValues = (list = []) => list.map(item => {
        const newObj = {
            attachmentId: item.attachmentId,
            sequence: item.sequence
        }
        return newObj
    })

    if(!checkScope(`${_routePermission}:create`) || !checkScope(`${_routePermission}:update`) || !checkScope(`${_routePermission}:view`)) {
        return <Error401 />
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={`${PAGE_VIEW} ${_pageName}`}
                        breadcrumbItems={[
                            { title: _pageName, link: "" },
                            { title: PAGE_VIEW },
                        ]}
                    />

                    {/* Render Form */}
                    {
                        contentLoading
                            ? <Spinners setLoading={setContentLoading} />
                            :
                            <Row>
                                <Col className="col-12">
                                    <FormikProvider value={validation}>
                                        <Form
                                            className="form-horizontal"
                                            onSubmit={(e) => {
                                                e.preventDefault();
                                                validation.handleSubmit();
                                                return false;
                                            }}
                                        >
                                            <Row>
                                                <Col className="col-8">
                                                    <Card>
                                                        <h5 className="card-header bg-transparent border-bottom text-uppercase">
                                                            <i className='bx bx-cube-alt'></i> {_pageName}
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col md={12} className="mb-3">
                                                                    <Label
                                                                        htmlFor="contentDetail"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Section Detail
                                                                        <span className="t-require">*</span>
                                                                    </Label>
                                                                    <Col md={12}>
                                                                        <MyEditor
                                                                            id="contentDetail"
                                                                            placeholder=""
                                                                            name="contentDetail"
                                                                            onChange={(e, editor) => {
                                                                                const data = editor.getData()
                                                                                validation.setFieldValue(
                                                                                    "contentDetail",
                                                                                    data
                                                                                )
                                                                                console.log({ e, editor, data })
                                                                            }}
                                                                            onBlur={validation.handleBlur}
                                                                            value={validation.values.contentDetail}
                                                                            invalid={
                                                                                validation.touched.contentDetail &&
                                                                                    validation.errors.contentDetail
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                            disabled={pageView === "view"}
                                                                            isError={
                                                                                validation.touched.contentDetail &&
                                                                                    validation.errors.contentDetail
                                                                                    ? true
                                                                                    : false
                                                                            }
                                                                        />
                                                                    </Col>
                                                                </Col>
                                                                <Col md={12}>
                                                                    <PopupAttachment
                                                                        typeDetail="single"
                                                                        typeUpload="ImageMap"
                                                                        upload="Image"
                                                                        prefixName={`section-worldclass-bg`}
                                                                        label="Background Image"
                                                                        required={false}
                                                                        description="description"
                                                                        widthSize={2160}
                                                                        heightSize={1266}
                                                                        value={validation.values.worldclassBg}
                                                                        onChange={(value = {}, index) => {
                                                                            console.log("🚀 onChange ~ value:", value)
                                                                            console.log("🚀 onChange ~ index:", index)
                                                                            validation.setFieldValue('worldclassBg', value)
                                                                        }}
                                                                        onRemove={(index) => {
                                                                            console.log("🚀 onChange ~ index:", index)
                                                                            validation.setFieldValue('worldclassBg', {})
                                                                        }}
                                                                    />
                                                                    {validation.touched.worldclassBg && validation.errors.worldclassBg && (
                                                                        <div type="invalid" className="invalid-feedback d-block">
                                                                            {validation.errors.worldclassBg}
                                                                        </div>
                                                                    )}
                                                                </Col>
                                                                <hr />
                                                            </Row>
                                                            <ReactSortable
                                                                list={cardSeq}
                                                                setList={handleSortEnd}
                                                                animation={150}
                                                                id="sort-worldclass"
                                                                className="row"
                                                                handle=".drag-handle"
                                                            >
                                                                { 
                                                                    cardSeq.map((itemNo, index) => {
                                                                        const tmpConfig = {
                                                                            '1': contentCard1Show,
                                                                            '2': contentCard2Show,
                                                                            '3': contentCard3Show,
                                                                            '4': contentCard4Show,
                                                                            '5': contentCard5Show,
                                                                        }

                                                                        if (tmpConfig[itemNo] == undefined) {
                                                                            return <></>
                                                                        }
                                                                        return <CardPieceWorldclass key={itemNo} runningNo={index+1} pageView={pageView} validation={validation} cardNumber={itemNo} contentCardShow={tmpConfig[itemNo]}/>
                                                                })}
                                                            </ReactSortable>
                                                        </CardBody>
                                                    </Card>
                                                </Col>
                                                <Col className="col-4">
                                                    <Card outline color="primary" className="border sticky-element">
                                                        <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                                                            <i className='bx bx-check'></i> Tools Box
                                                        </h5>
                                                        <CardBody>
                                                            <Row>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Switch Language
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputLang widthfull pageView={pageView} forceRoute={false} />
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Written at
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <InputGroup>
                                                                            <Flatpickr
                                                                                className="form-control d-block"
                                                                                options={{
                                                                                    dateFormat: 'd/m/Y', // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                                                                }}
                                                                                value={validation.values.contentUpdateDate ? moment(validation.values.contentUpdateDate, 'YYYY-MM-DD').toDate() : null}
                                                                                disabled={true}
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-secondary docs-datepicker-trigger"
                                                                                    disabled
                                                                                >
                                                                                    <i className="fa fa-calendar" aria-hidden="true" />
                                                                                </button>
                                                                            </div>
                                                                        </InputGroup>
                                                                        {
                                                                            (validation.touched.contentUpdateDate && validation.errors.contentUpdateDate) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentUpdateDate}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                                <Col className="col-12 mb-3">
                                                                    <label
                                                                        htmlFor="category_name"
                                                                        className="col-md-12 col-form-label"
                                                                    >
                                                                        Display
                                                                        <span className="t-require">*</span>
                                                                    </label>
                                                                    <div className="col-md-12">
                                                                        <Select
                                                                            placeholder="Select Status"
                                                                            value={fn_helper.FNFORM.getObjectValue(STATUS_OPTION, `${validation.values.contentStatus}`)}
                                                                            onChange={(value) => validation.setFieldValue("contentStatus", value.id)}
                                                                            getOptionValue={(option) => option.id}
                                                                            getOptionLabel={(option) => option.name}
                                                                            options={STATUS_OPTION}
                                                                            className={`select2-selection ${validation.touched.contentStatus && validation.errors.contentStatus ? "input-err" : ""}`}
                                                                            isDisabled={pageView === "view"}
                                                                        />
                                                                        {
                                                                            (validation.touched.contentStatus && validation.errors.contentStatus) && (
                                                                                <div type="invalid" className="invalid-feedback d-block">{validation.errors.contentStatus}</div>
                                                                            )
                                                                        }
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </CardBody>
                                                        <CardFooter>
                                                            <Row>
                                                                {/* <Col className="text-start">
                                                                    <Button color="danger" className="btn btn-danger" onClick={() => navigate(`/pdpa/page-setting/${qLang}`)}>Back</Button>
                                                                </Col> */}
                                                                <Col className="text-end">
                                                                    {pageView !== 'view' && (
                                                                        <Button type="submit" className="btn btn-success">
                                                                            Save  {waitSendData ? <Spinner size="sm" color="light" /> : null}
                                                                        </Button>
                                                                    )}
                                                                </Col>
                                                            </Row>
                                                        </CardFooter>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </FormikProvider>
                                </Col>
                            </Row>
                    }
                </Container>
            </div>
        </React.Fragment>
    )
}

export default withTranslation()(BusinessPurposeWorldclassTemplate)
